import Button from "components/button/Button";
import FormInput from "components/formInput/Input";
import InputPassword from "components/formInput/InputPassword";
import { ERROR_MSG, ROLE_VALUE } from "constants/Constants";
import { useFormik } from "formik";
import useAppDispatch from "hooks/useAppDispatch";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ROUTE } from "routes/route";
import * as Yup from "yup";
import "./styles.scss";

const Login = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const {
    actions: { actLogin, actGetUserInfo },
  } = useAppDispatch();

  const onSubmit = async (values) => {
    actLogin(values, () => {
      handleLoginSuccess();
    });
  };

  const handleLoginSuccess = () => {
    actGetUserInfo({}, (userInfo) => {
      history.push(
        userInfo.role === ROLE_VALUE.ADMIN
          ? ROUTE.ADMIN.PATIENTS
          : userInfo?.first_login
          ? ROUTE.CLINIC.FIRST_PAGE
          : ROUTE.CLINIC.PATIENT
      );
    });
  };

  const formik = useFormik({
    validateOnChange: false,
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required(ERROR_MSG.REQUIRE),
      // .min(8, ERROR_ID_LENGTH)
      // .max(8, ERROR_ID_LENGTH),
      password: Yup.string()
        .required(ERROR_MSG.REQUIRE)
        .min(8, ERROR_MSG.PW_LOGIN_RULE)
        .max(36, ERROR_MSG.PW_LOGIN_RULE),
    }),
    onSubmit,
  });
  const { username, password } = formik.values;

  const onForgotPassword = () => {
    history.push(ROUTE.PUBLIC.RESET_PASSWORD);
  };

  const onDeleteAccount = () => {
    history.push(ROUTE.PUBLIC.DELETE_ACCOUNT);
  };

  const handleClickAbout = () => {
    window.open(
      "https://www.urinescope.com/",
      "_blank" // <- This is what makes it open in a new window.
    );
  };

  return (
    <form className="login-container" onSubmit={formik.handleSubmit}>
      <div className="login-form">
        <img src="/icons/logo.webp" className="login-logo-icon" />
        <div className="login-title">不安のない健やかな眠りをサポ―ト</div>
        <FormInput
          title="ログインID"
          value={username}
          error={formik.errors.username}
          onChange={formik.handleChange}
          name="username"
        />

        <InputPassword
          title={t("login.password")}
          subtitle={t("login.passwordDes")}
          type="password"
          name="password"
          value={password}
          error={formik.errors.password}
          onChange={formik.handleChange}
        />

        <div className="forgot-password" onClick={onForgotPassword}>
          {t("login.forgotPassword")}
        </div>
        <div className="forgot-password" onClick={onDeleteAccount}>
          アカウント削除
        </div>
        <Button
          disabled={!username || !password}
          style={{ fontSize: 20, fontWeight: 900, borderRadius: 60 }}
          text={t("button.login")}
          type="submit"
          className="login-button"
        />
        <Button
          // disabled={!id || !password}
          text={t("login.registration")}
          type="submit"
          className="registration-button"
          style={{ fontSize: 20, fontWeight: 900, borderRadius: 60 }}
          onClick={() => {
            history.push(ROUTE.PUBLIC.TERMS_POLICY.replace(":id", 0));
          }}
        />
        <div className="login-info-and-policy">
          <div className="login-info about-urine" onClick={handleClickAbout}>
            {t("login.aboutUrine")}
          </div>
          <div
            className="login-policy"
            onClick={() => {
              history.push(ROUTE.PUBLIC.TERMS_POLICY.replace(":id", 1));
            }}
          >
            {t("login.termAndPolicy")}
          </div>
        </div>
      </div>
    </form>
  );
};
export default Login;
